import React, { Component } from 'react';
import styles from './ErrorBoundary.module.css';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className={styles.container}>
          <div className={styles.card}>
            <span className={`material-symbols-outlined ${styles.icon}`}>
              warning
            </span>
            <h1 className={styles.title}>¡Algo salió mal!</h1>
            <p className={styles.message}>
              Lamentamos el inconveniente. Se ha producido un error inesperado al cargar esta sección.
            </p>
            {this.state.error && (
              <pre className={styles.errorDetails}>
                {this.state.error.toString()}
              </pre>
            )}
            <button className={styles.retryBtn} onClick={this.handleReset}>
              Recargar página
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
